import React from "react";
import classnames from "classnames";

import { InfoRow } from "../../types";

import styles from "./DetailsInfoBlock.module.scss";

export interface Props {
  rows: InfoRow[];
  rowClassName?: string;
}

export const DetailsInfoBlock = (props: Props) => {
  const { rows, rowClassName = "" } = props;

  return (
    <>
      {rows.map((row) => (
        <div
          key={row.key || `${row.label}${row.value}`}
          className={classnames(styles.row, {
            [styles.headerRow]: row.type === "title",
            [rowClassName]: row.type === "title",
            [styles.subHeaderRow]: row.type === "subtitle",
          })}
        >
          <span>{row.label}</span>
          <span className={styles.rowValue}>{row.value}</span>
        </div>
      ))}
    </>
  );
};

export default DetailsInfoBlock;
